import { useNavigate, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function BuyerTermsPage() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#151613] text-[#f1e0c5] px-6 py-10" data-testid="buyer-terms-page">
      <div className="max-w-2xl mx-auto space-y-8">
        <button data-testid="buyer-terms-back-button" onClick={() => navigate(-1)} className="flex items-center gap-1.5 text-xs text-[#f1e0c5]/50 hover:text-[#D4AF37] transition-colors duration-200">
          <ArrowLeft className="w-3.5 h-3.5" /> Back
        </button>
        <div>
          <h1 className="font-display text-4xl">Bazaar Buyer Terms</h1>
          <p className="text-xs text-[#f1e0c5]/40 mt-2">Why Not? LTD (Ohio, United States)</p>
        </div>
        <p className="text-sm text-[#f1e0c5]/70 leading-relaxed">
          All sales are under sales conditions of the individual merchant's return policies. All
          sales made have no connection with Call to Arms or Why not? LTD and all proceeds go to
          the merchant. We will never charge you or the sellers extra fees, please report anyone
          trying to charge fees in our name. Enjoy and stay safe.
        </p>
        <p className="text-xs text-[#f1e0c5]/30 pt-4 border-t border-white/5">
          Selling on the Bazaar? See the{" "}
          <Link to="/legal/seller-terms" data-testid="buyer-terms-seller-terms-link" className="text-[#D4AF37] underline">Seller Terms & Conditions</Link>.
        </p>
      </div>
    </div>
  );
}
